import Slider from 'react-slick';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './weconnect.css';
import './bem.css';
const data = require('./lang/lang.json');

class KondFest6 extends Component {
  state = {
    showItem: '',
  };

  render() {
    const text = data[localStorage.getItem('language')];

    return (
      <section className='main-container current-container slider-centered'>
        <div className='breadcrumb container'>
          <a href='/kond_fest'>{text.kond}/</a>
          <a href='/KondFest6' className='breadcrumb-active'>
            {text.kond5}
          </a>
        </div>
        <div className='section-details modal-slider'>
          <div className='row m-0 position-relative'>
            <div className='white-decoration'>
              <img src='images/white-svg.svg' alt='asv' />
            </div>
            <div className='col-lg-6 p-0 pr-lg-4'>
              <img src='images/kondFest6/image.jpg' alt='kondfest' />
            </div>
            <div className='main-description-banner col-lg-5'>
              <b>
                <p dangerouslySetInnerHTML={{ __html: text.kond6 }}></p>
              </b>
              <div className='info-block'>
                <p dangerouslySetInnerHTML={{ __html: text.kond_fest_6_desc }}></p>
              </div>
              <br />
            </div>
            <a href='/kondFest1' className='col-lg-1 p-0 next-page desktop-next'>
              <p> {text.next}</p>
              <img src='images/arrow.svg' alt='' />
            </a>
          </div>
          <div className='text-center'>
            <p className='text-center mb-5 photo-by'></p>
            <div id='video-link-rape' className='video-link'>
              <iframe
                width='560'
                height='315'
                src='https://www.youtube.com/embed/llKHkYPTjKA'
                title='YouTube video player'
                frameborder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <a href='/kondFest1' className='col-lg-1 p-0 next-page mobile-next'>
            <p> {text.next}</p>
            <img src='images/arrow.svg' alt='' />
          </a>
        </div>
      </section>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  setLanguage: (language) => dispatch({ type: 'SET_LANGUAGE', language }),
});

const mapStateToProps = (state) => {
  return { language: state.language };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KondFest6));
